export const isValidEmail = (email?: string | null): boolean => {
  if (!email || typeof email !== "string") return false; // ✅ guard clause
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};
